<!-- 弃用 -->
<template>
  <div class="header-container">
    <router-link :to="{ name: 'userinfo'}">
      <div class="profile-header">
        <div class="profile-content">
          <div class="avatar-container">
            <img class="avatar-image" :src="headimgurl" alt="用户头像" />
          </div>
          <div class="user-details">
            <h2 class="username">{{username}}</h2>
            <p class="mobile-number">
              <van-icon name="phone-o" size="14" />
              {{mobile}}
            </p>
          </div>
        </div>
        <div class="edit-profile">
          <span class="edit-text">修改信息</span>
          <van-icon name="arrow" color="#999" />
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: this.$store.state.wx_info.username?this.$store.state.wx_info.username:this.$store.state.wx_info.nickname,
      mobile: this.$store.state.wx_info.mobile,
      headimgurl: require('@/assets/images/avatar2.jpg'),
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  padding: 0.75rem 1rem;
  // background-color: #fff;
}

.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 1rem;
  background: linear-gradient(135deg, #4080ff 0%, #3a6df0 100%);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.profile-content {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.avatar-container {
  margin-right: 1rem;
  
  .avatar-image {
    width: 3.75rem;
    height: 3.75rem;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    object-fit: cover;
  }
}

.user-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex: 1;
  
  .username {
    margin: 0;
    padding: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #fff;
    margin-bottom: 0.8rem;
    white-space: nowrap; /* 防止换行 */
    overflow: hidden; /* 隐藏溢出内容 */
    text-overflow: ellipsis; /* 显示省略号 */
    max-width: 100%; /* 确保不超过容器宽度 */
  }
  
  .mobile-number {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.85);
    
    .van-icon {
      margin-right: 4px;
    }
  }
}

.edit-profile {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.1rem 0.5rem 0.5rem ;
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  margin-left: 0.5rem;
  flex-direction: row;
  white-space: nowrap;
  gap: 3px;
  
  .edit-text {
    font-size: 0.875rem;
    color: #fff;
    display: inline-block;
  }
  
  .van-icon {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
